import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-FlagLuxembourg-lusenbao",
  "use": "icon-FlagLuxembourg-lusenbao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-FlagLuxembourg-lusenbao\"><defs><style type=\"text/css\"></style></defs><path d=\"M23.272727 134.981818h977.454546v218.763637H23.272727z\" fill=\"#D75D47\" p-id=\"5445\" /><path d=\"M23.272727 351.418182h977.454546v214.109091H23.272727z\" fill=\"#FFFFFF\" p-id=\"5446\" /><path d=\"M23.272727 565.527273h977.454546v218.763636H23.272727z\" fill=\"#1692D0\" p-id=\"5447\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol